<template>
  <div>
    <!-- auth screen -->
    <div v-if="this.$route.meta.authScreen">
      <router-view />
    </div>
    <!-- dashboard -->
    <div v-else>
      <div class="dash wrapper d-flex align-items-stretch">
        <SideBar />
        <div id="content" class="content-view position-relative active">
          <div class="right-box bg-lightgray rounded px-4">
            <NavBar />
            <router-view />
            <h6></h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/components/layouts/SideBar.vue'
import NavBar from '@/components/layouts/NavBar.vue'
export default {
  components: { SideBar, NavBar },
}
</script>